import axios from 'axios'
import querystring from 'querystring'

// Initial state
const state = {
  mailServerHost: null,
  mailServerPort: null,
  mailServerUser: null,
  mailServerPassword: null,
  mailFromEmail: null,
  mailFromName: null
}

// Mutations
const mutations = {
  setMailServerHost (state, host) {
    // console.log('Got mail server host: ' + host)
    state.mailServerHost = host
  },
  setMailServerPort (state, port) {
    // console.log('Got mail server port: ' + port)
    state.mailServerPort = port
  },
  setMailServerUser (state, user) {
    state.mailServerUser = user
  },
  setMailServerPassword (state, password) {
    state.mailServerPassword = password
  },
  setMailFromEmail (state, fromEmail) {
    state.mailFromEmail = fromEmail
  },
  setMailFromName (state, fromName) {
    state.mailFromName = fromName
  }
}

// Actions
const actions = {
  loadMailServerConfiguration ({ commit, state }, ctx) {
    return new Promise((resolve, reject) => {
      // console.log('Get mail server configuration')
      let salesOrganizationParameter = ctx && ctx.salesOrganization ? '?salesOrganization=' + ctx.salesOrganization.id : ''
      commit('setMailServerHost', '')
      commit('setMailServerPort', '')
      commit('setMailServerUser', '')
      commit('setMailServerPassword', '')
      commit('setMailFromEmail', '')
      commit('setMailFromName', '')

      // Call the backend
      axios.all([
        axios.get('/backend/rest/configuration/MailServerHost' + salesOrganizationParameter)
          .then(response => {
            commit('setMailServerHost', response.data.value)
          })
          .catch(error => {
            reject(Error(error.response.data))
          }),
        axios.get('/backend/rest/configuration/MailServerPort' + salesOrganizationParameter)
          .then(response => {
            commit('setMailServerPort', response.data.value)
          })
          .catch(error => {
            reject(Error(error.response.data))
          }),
        axios.get('/backend/rest/configuration/MailServerUser' + salesOrganizationParameter)
          .then(response => {
            commit('setMailServerUser', response.data.value)
          })
          .catch(error => {
            reject(Error(error.response.data))
          }),
        axios.get('/backend/rest/configuration/MailServerPassword' + salesOrganizationParameter)
          .then(response => {
            commit('setMailServerPassword', response.data.value)
          })
          .catch(error => {
            reject(Error(error.response.data))
          }),
        axios.get('/backend/rest/configuration/MailFromEmail' + salesOrganizationParameter)
          .then(response => {
            commit('setMailFromEmail', response.data.value)
          })
          .catch(error => {
            reject(Error(error.response.data))
          }),
        axios.get('/backend/rest/configuration/MailFromName' + salesOrganizationParameter)
          .then(response => {
            commit('setMailFromName', response.data.value)
          })
          .catch(error => {
            reject(Error(error.response.data))
          })
      ]).then(axios.spread(function (userResponse, reposResponse) {
        resolve('Success')
      }))
    })
  },
  saveMailServer ({ commit, state }, mailServer) {
    return new Promise((resolve, reject) => {
      console.log('Save mail server configuration')

      // Call the backend
      axios.post('/backend/rest/configuration', querystring.stringify({ key: 'MailServerHost', value: mailServer.host, salesOrganization: mailServer.salesOrganization.id }))
      axios.post('/backend/rest/configuration', querystring.stringify({ key: 'MailServerPort', value: mailServer.port, salesOrganization: mailServer.salesOrganization.id }))
      axios.post('/backend/rest/configuration', querystring.stringify({ key: 'MailServerUser', value: mailServer.user, salesOrganization: mailServer.salesOrganization.id }))
      axios.post('/backend/rest/configuration', querystring.stringify({ key: 'MailServerPassword', value: mailServer.password, salesOrganization: mailServer.salesOrganization.id }))
      axios.post('/backend/rest/configuration', querystring.stringify({ key: 'MailFromEmail', value: mailServer.fromEmail, salesOrganization: mailServer.salesOrganization.id }))
      axios.post('/backend/rest/configuration', querystring.stringify({ key: 'MailFromName', value: mailServer.fromName, salesOrganization: mailServer.salesOrganization.id }))
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/configuration.js